let usage = `
  <DraggableList
    :list="dragList"
    :headers="headers"
    @update:list="updateDraggableLists"
  />
`;

export default {
  usage
};
